<template>
  <div class="spinnerOverlay">
    <div class="spinnerWrapper d-flex justify-center items-center">
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script setup>
// スピナーコンポーネントがマウントされたときに、bodyのスクロールを無効にする
import { onMounted, onUnmounted } from 'vue';

onMounted(() => {
  document.body.style.overflow = 'hidden';
});

onUnmounted(() => {
  document.body.style.overflow = '';
});
</script>

<style scoped>
.spinnerOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinnerWrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  opacity: 0.7;
  width: 60px;
  height: 60px;
  border: 5px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: #21963b;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
